class NewsApi {
  constructor(el) {
    this.dom = {el: el};

    this.url = '/ja/news_files/json/news.json';
    this.html = null;

    this.init();
  }

  init() {
    const _this = this;

    fetch(this.url,
        {
          method: 'GET',
          // mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then(response => {
        return response.json();
      })
      .then(json => {
        let data = json.items;
        data.sort(function(a, b) {
          return (a.date > b.date) ? -1 : 1; // 日付順にソート
        });
        this.dom.el.innerHTML = this.createHtml(data);
      });
  }

  createHtml(_data) {
    this.html = '';
    for (let i = 0; i < 5; i++) {
      // console.log(new Date(_data[i].date).toLocaleDateString('ja-JP', {year: 'numeric', month: '2-digit', day: '2-digit'}));
      const dateY = new Date(_data[i].date).toLocaleDateString('en-US', {year: 'numeric'});
      const dateM = new Date(_data[i].date).toLocaleDateString('en-US', {month: 'long'}).toUpperCase();
      const dateD = new Date(_data[i].date).toLocaleDateString('en-US', {day: '2-digit'});
      this.html += `
        <li class="hm-news-list">
          <a href="${_data[i].url}" target="_blank" class="hm-news-list__inner">
            <time datetime="${_data[i].date}" class="hm-news-list__time">${dateM} ${dateD} <span>${dateY}</span></time>
            <span class="hm-news-list__title">${_data[i].title}</span>
          </a>
        </li>
      `;
      if (i === 4) continue;
    }
    return this.html;
  }
}

export default NewsApi
